<template>
  <div class="zenify-popup-page">
    <ZenifyIndex
      :showDialer="true"
      :isPopup="true"
      :phoneNumber="initialPhone"
    />
  </div>
</template>

<script>
import ZenifyIndex from "./ZenifyIndex.vue";
import { ZENIFY_HEARTBEAT_KEY, sendZenifyMessage } from "@/core/services/zenifyChannel";

export default {
  name: "ZenifyPopup",
  components: {
    ZenifyIndex
  },
  data() {
    return {
      heartbeatTimer: null,
      releaseLock: null
    };
  },
  computed: {
    initialPhone() {
      return this.$route.query.phone || "";
    }
  },
  mounted() {
    document.title = "Zenify Softphone - Edutalk";
    document.body.classList.add("zenify-popup-body");

    // 1. Kiểm tra Single-Instance qua Web Locks API: Nếu đã có 1 cửa sổ Zenify khác chạy, tự động đóng cửa sổ này
    if (typeof navigator !== "undefined" && navigator.locks && navigator.locks.request) {
      navigator.locks.request("zenify_single_window_lock", { ifAvailable: true }, async (lock) => {
        if (!lock) {
          // Đã có 1 cửa sổ Zenify khác đang chạy
          sendZenifyMessage({ type: "FOCUS", phone: this.initialPhone });
          if (this.initialPhone) {
            sendZenifyMessage({ type: "DIAL", phone: this.initialPhone });
          }
          window.close();
          return;
        }
        await new Promise((resolve) => {
          this.releaseLock = resolve;
        });
      });
    }

    // 2. Heartbeat để các tab CRM biết cửa sổ Zenify đang hoạt động
    this.updateHeartbeat();
    this.heartbeatTimer = setInterval(this.updateHeartbeat, 1000);

    window.addEventListener("beforeunload", this.cleanupPopup);
  },
  beforeDestroy() {
    this.cleanupPopup();
  },
  methods: {
    updateHeartbeat() {
      try {
        localStorage.setItem(ZENIFY_HEARTBEAT_KEY, String(Date.now()));
      } catch (e) {}
    },
    cleanupPopup() {
      document.body.classList.remove("zenify-popup-body");
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
      try {
        localStorage.removeItem(ZENIFY_HEARTBEAT_KEY);
      } catch (e) {}
      if (this.releaseLock) {
        this.releaseLock();
        this.releaseLock = null;
      }
      window.removeEventListener("beforeunload", this.cleanupPopup);
    }
  }
};
</script>

<style>
/* Ẩn thanh cuộn và nút Zalo nổi khi mở cửa sổ popup softphone */
body.zenify-popup-body {
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
  background-color: #f8fafc !important;
}

body.zenify-popup-body .bounce-animation,
body.zenify-popup-body img[alt="logo-zalo"] {
  display: none !important;
}
</style>

<style scoped>
.zenify-popup-page {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
